/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assign_Driver_NoneInputs */

const vi_assign_driver_none = /** @type {(inputs: Assign_Driver_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có tài xế nào đang hoạt động`)
};

/**

* @param {Assign_Driver_NoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const assign_driver_none = /** @type {((inputs?: Assign_Driver_NoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assign_Driver_NoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_assign_driver_none(inputs)
});